import {
  AlertDialog as AlertDialogUIShadcn,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { PropsWithChildren, useState } from "react";
import { useTranslation } from "react-i18next";

type AlertDialogProps = PropsWithChildren & {
  callBack?: () => Promise<void> | void;
  isLoading: boolean;
  title?: string;
  description: string;
  disabled?: boolean;
};

export function AlertDialog({
  children,
  callBack,
  isLoading,
  title,
  description,
  disabled,
}: AlertDialogProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  async function handleCallBack() {
    if (typeof callBack === "function") {
      await callBack();
      setTimeout(() => {
        setOpen(isLoading);
      }, 1000);
    }
  }
  return (
    <AlertDialogUIShadcn open={open} onOpenChange={setOpen}>
      <AlertDialogTrigger disabled={isLoading || disabled} asChild>
        {children}
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {" "}
            {title || `${t("LABEL.are you sure")} ?`}
          </AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>{t("LABEL.cancel")}</AlertDialogCancel>
          <Button
            disabled={isLoading}
            isLoading={isLoading}
            onClick={handleCallBack}
            className="bg-green-600 hover:bg-green-600/80 text-white"
          >
            {t("LABEL.confirm")}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialogUIShadcn>
  );
}
